// extracted by mini-css-extract-plugin
export default {"cardContainer":"Card_cardContainer__9qOE1","card":"Card_card__YHGVW"};